var escape = require("../../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1nASZ7ymB-Yph4auoEvEHS {\n    position: absolute;\n    top: 30px;\n    left: 0;\n    transition: transform 300ms ease-out, opacity 50ms ease-out;\n    opacity: 1;\n    cursor: pointer;\n    z-index: 999;\n}\n\n._3uT7kR09RcyEN0C-Hbo9On {\n    opacity: 0;\n    pointer-events: none;\n}\n\n._2cO9PI9OCJSzYCbca0ewFK {\n    background: url(" + escape(require("../../img/back_button.svg")) + ") no-repeat;\n    width: 11px;\n    height: 18px;\n    display: block;\n}\n", ""]);

// exports
exports.locals = {
	"backButton": "_1nASZ7ymB-Yph4auoEvEHS",
	"backButtonFade": "_3uT7kR09RcyEN0C-Hbo9On _1nASZ7ymB-Yph4auoEvEHS",
	"leftArrowIcon": "_2cO9PI9OCJSzYCbca0ewFK"
};